/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CustomerWalletTransactionsPathParams,
	CustomerWalletTransactionsResponse,
} from '../types/CustomerWalletTransactions'

/**
 * GET /:organisation/wallet/transactions
 * @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::transactions
 */
export async function customerWalletTransactions(
	organisation: CustomerWalletTransactionsPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomerWalletTransactionsResponse>> {
	return axiosInstance.get(`/${organisation}/wallet/transactions`, config)
}
